import * as angular from "angular";
import { ConsentType } from "../models/consent-type.model";
import { ConsentTypeService } from "../services/consent-type.service";

export class ConsentTypeDataProvider {
    private $q: any;
    private service: ConsentTypeService;
    public consentTypes: ConsentType[];

    constructor($q: any, ConsentTypeService: ConsentTypeService) {
        this.$q = $q;
        this.service = ConsentTypeService;
    }

    all(): Promise<ConsentType[]> {
        const deferred = this.$q.defer();
        if (!this.consentTypes) {
            this.service.all().then(
                (response) => {
                    const json = response["data"];
                    this.consentTypes = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.consentTypes.push(new ConsentType(json.data[i]));
                    }
                    deferred.resolve(this.consentTypes);
                },
                (error) => {
                    this.consentTypes = [];
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.consentTypes);
        }
        return deferred.promise;
    }

    create(consentType: any): Promise<ConsentType> {
        const deferred = this.$q.defer();
        this.service.create(consentType).then(
            (response) => {
                const json = response["data"];
                if (json.success) {
                    let consentType = new ConsentType(json.data);
                    this.consentTypes.push(consentType);
                    deferred.resolve(consentType);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    update(consentType) {
        const deferred = this.$q.defer();
        this.service.update(consentType).then((response) => {
            const json = response["data"];
            if (json.success) {
                consentType.setData(json.data);
                deferred.resolve(consentType);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    delete(consentType: ConsentType): Promise<any> {
        const deferred = this.$q.defer();
        this.service.delete(consentType).then((response) => {
            const json = response["data"];
            if (json.success) {
                this.spliceConsentType(consentType);
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    deactivate(consentType: ConsentType): Promise<ConsentType> {
        const deferred = this.$q.defer();
        this.service.deactivate(consentType).then((response) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(consentType);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    clearAll(): void {
        this.consentTypes = null;
    }

    consentTypeWithID(id?: string, consentTypes?: ConsentType[]) {
        let existingConsentType = null;
        angular.forEach(consentTypes, (consentType) => {
            if (consentType.id == id) {
                existingConsentType = consentType;
            }
        });
        if (existingConsentType) {
            return existingConsentType;
        } else {
            return false;
        }
    }

    spliceConsentType(consentType) {
        let consentTypesIndex = this.consentTypes
            .map((consentType: ConsentType) => consentType.id)
            .indexOf(consentType.id);

        if (consentTypesIndex > -1) {
            this.consentTypes.splice(consentTypesIndex, 1);
        }
    }

    replaceConsentType(consentType) {
        let type = this.consentTypeWithID(consentType.id);
        type.setData(consentType);
    }

    processSocketUpdate(socketData) {
        if (this.consentTypes) {
            this.replaceConsentType(new ConsentType(socketData));
        }
    }

    processSocketCreate(socketData) {
        if (this.consentTypes) {
            this.replaceConsentType(new ConsentType(socketData));
        }
    }

    processSocketDelete(socketData) {
        if (this.consentTypes) {
            let consentType = this.consentTypeWithID(socketData.id);
            this.spliceConsentType(consentType);
        }
    }
}

angular
    .module("vcDataProvider")
    .service("ConsentTypeDataProvider", ConsentTypeDataProvider);
